import React, { useEffect } from 'react'

// Use
import useQuery from 'use/query'

// Components
import Header from 'ui/Header'
import Navbar from 'ui/Navbar'
import Container from 'ui/Container'
import Footer from 'ui/Footer'
import Heading from 'ui/Heading'
import Text from 'ui/Text'
import Row from 'ui/Row'
import Col from 'ui/Col'
import ListCategory from 'components/Ticketing/Support/ListCategory'
import ListOpenTickets from 'components/Ticketing/ListOpenTickets'
import TicketForm from 'components/Ticketing/TicketForm'

export default function PageSupport() {
  const { lessorId } = useQuery()

  useEffect(() => {
    if (lessorId) {
      const ticketEl = document.getElementById('ticketing_create_form')
      if (ticketEl) {
        ticketEl.scrollIntoView()
      }
    }
  }, [lessorId])

  return (
    <>
      <Header />
      <Navbar />
      <Container>
        <Row style={{ margin: '0px' }}>
          <Col sm={{ span: 12 }}>
            <Heading paddingBottom={0}>Help & support</Heading>
            <Text paddingBottom={20}>
              Need help? Check out the user manuals below or browse our answers
              to the Frequently Asked Questions. <br /> Should you need further
              assistance, you may send us a message.
            </Text>
          </Col>
        </Row>
        <Row style={{ margin: '0px' }} multiline>
          <Col md={{ span: 12 }}>
            <ListCategory />
          </Col>
        </Row>
        <Row multiline id="ticketing_create_form">
          <Col sm={{ span: 7 }}>
            <Text size={18} color="#000" bold paddingTop={40}>
              Create a ticket
            </Text>
            <Text color="#000" paddingBottom={10}>
              Send us a message by creating a ticket and our support team will
              get back to you
            </Text>
          </Col>
        </Row>
        <Row multiline>
          <Col md={{ span: 7 }}>
            <TicketForm />
          </Col>
          <Col md={5}>
            <Row>
              <Col xs={12} md={{ span: 11, offset: 1 }}>
                <ListOpenTickets />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  )
}
